import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import _ from 'lodash';
import { useTranslations } from 'next-intl';
import * as React from 'react';
import { toast } from 'react-toastify';
import * as GTM from '../../lib/GTM';
import useCartStore from '../../stores/cart/store';

interface IProps {
  product: SearchProduct;
  hasNotBorders?: boolean;
}

const CartCounter = ({
  product,
  hasNotBorders,
}: IProps): React.ReactElement<any> => {
  const t = useTranslations('common');

  const cart = useCartStore();

  const productInCart = _.find(cart.items, (item) => {
    return item.product.id === product.id;
  });

  const addProductInCart = (): void => {
    if (productInCart && productInCart.quantity >= product.stock) {
      if (!toast.isActive(1)) {
        toast.success(t('CartCounter.message'), {
          toastId: 1,
        });
      } else {
        toast.update(1, {
          render: t('CartCounter.message'),
        });
      }
      return;
    }

    GTM.addToCart(product, (productInCart?.quantity || 0) + 1);
    cart.addItem(product);
  };

  const removeProductFromCart = (): void => {
    cart.removeItem(product);
  };

  return (
    <form className="max-w-[150px] block relative mb-0" method="get">
      <span className="inline-block absolute top-[50%] left-[10px] translate-x-2/4 translate-y-2/4">
        <button type="button" onClick={() => removeProductFromCart()}>
          <i className="icon-minus" />
        </button>
      </span>
      <span className="inline-block absolute top-[50%] translate-x-2/4 translate-y-2/4">
        <button type="button" onClick={() => addProductInCart()}>
          <i className="icon-plus" />
        </button>
      </span>
      <input
        className="form-input rounded-md text-center"
        style={hasNotBorders ? { border: 0 } : {}}
        type="text"
        value={(productInCart ? productInCart.quantity : 0).toString()}
        onChange={() => { return; }}
      />
    </form>
  );
};

export default CartCounter;
